import { Box, Typography, useTheme } from "@mui/material";
import profileImage from "../../../../../../../media/images/profileImage.svg";
import CarTagView from "../../../../../../components/CarTag";
import BigCompanyIcon from "../../../../../../../media/images/icons/company-big-icon";
import CalendarCheck from "../../../../../../../media/images/icons/calendar-check";
import CallOutlineSVG from "../../../../../../../media/images/icons/call-outline";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../../../../../hooks/useRedux";
import { IorderInfo } from "../..";
import { convertToJalali } from "../../../../../../../utils/functions";

export default function InfoContent(props: IorderInfo) {
  const theme = useTheme();
  const { fullName } = useAppSelector((state) => state.user);

  const {
    description,
    companyName,
    licenseNr,
    senderInfo,
    operatorInfo,
    senderAddress,
  } = props;

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "3px",
          }}
        >
          <img
            width={30}
            height={30}
            style={{
              borderRadius: "50%",
            }}
            src={profileImage}
            alt=""
          />
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: "700",
            }}
          >
            {fullName}
          </Typography>
        </Box>
        <CarTagView />
      </Box>
      <Box
        sx={{
          mt: 1,
          borderRadius: "8px",
          backgroundColor: "bgColor.grey100",
          boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
          padding: "6px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <BigCompanyIcon size={16} color={theme.palette.primary.main} />
          <Typography
            sx={{
              color: "primary.main",
              fontSize: "10px",
              fontWeight: "600",
            }}
          >
            شرکت حمل و نقل:
          </Typography>
        </Box>
        <Typography
          sx={{
            fontSize: "12px",
          }}
        >
          {companyName}
        </Typography>
      </Box>
      <Box
        sx={{
          mt: 1,
          backgroundColor: theme.palette.primary[50],
          padding: "4px",
          borderRadius: "6px",
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            textAlign: "center",
            color: theme.palette.primary.main,
          }}
        >
          شماره مجوز: {licenseNr}
        </Typography>
      </Box>
      <Box
        sx={{
          mt: 1,
          borderRadius: "8px",
          backgroundColor: "bgColor.grey100",
          display: "flex",
          justifyContent: "space-between",
          boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
          padding: "6px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <CalendarCheck size={18} color={theme.palette.textColor.main} />
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: "600",
            }}
          >
            تاریخ دریافت مجوز:{" "}
          </Typography>
        </Box>
        <Typography
          sx={{
            fontSize: "12px",
          }}
        >
          {operatorInfo?.license?.insertDateTime &&
            convertToJalali(operatorInfo?.license?.insertDateTime)}
        </Typography>
      </Box>

      <Box
        sx={{
          mt: 1,
          boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
          borderRadius: "8px",
          backgroundColor: "bgColor.grey100",
          padding: "6px",
          display: "flex",
          flexDirection: "column",
          gap: "4px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <CallOutlineSVG size={16} color={theme.palette.primary.main} />
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "600",
              color: "primary.main",
            }}
          >
            اطلاعات تماس مبدا:
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            noWrap
            sx={{
              fontSize: "14px",
            }}
          >
            09151234567 <br />
            {senderInfo?.fullName}
          </Typography>
          <Link
            to={"tel:9155555555"}
            style={{
              display: "flex",
              gap: "3px",
              borderColor: theme.palette.primary.main,
              borderRadius: "6px",
              borderWidth: "1px",
              borderStyle: "solid",
              alignItems: "center",
              backgroundColor: theme.palette.background.default,
              padding: "6px",
            }}
          >
            <CallOutlineSVG size={16} color={theme.palette.primary.main} />
            <Typography
              sx={{
                fontSize: "14px",
                color: "primary.main",
              }}
            >
              تماس با مبدا{" "}
            </Typography>
          </Link>
        </Box>
      </Box>
      <Box
        sx={{
          mt: 1,
          boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
          borderRadius: "8px",
          backgroundColor: "bgColor.grey100",
          padding: "6px",
          display: "flex",
          flexDirection: "column",
          gap: "4px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <CallOutlineSVG size={16} color={theme.palette.success.main} />
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "600",
              color: "success.main",
            }}
          >
            اطلاعات تماس مقصد:
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            noWrap
            sx={{
              fontSize: "14px",
              fontWeight: "600",
            }}
          >
            09121234567 <br /> احمد محمدی
          </Typography>
          <Link
            to={"tel:9155555555"}
            style={{
              display: "flex",
              gap: "3px",
              borderColor: theme.palette.success.main,
              borderRadius: "6px",
              borderWidth: "1px",
              borderStyle: "solid",
              alignItems: "center",
              backgroundColor: theme.palette.background.default,
              padding: "6px",
            }}
          >
            <CallOutlineSVG size={16} color={theme.palette.success.main} />
            <Typography
              sx={{
                fontSize: "14px",
                color: "success.main",
              }}
            >
              تماس با مقصد{" "}
            </Typography>
          </Link>
        </Box>
      </Box>
      <Box
        sx={{
          mt: 1,
          boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
          borderRadius: "8px",
          backgroundColor: "bgColor.grey100",
          padding: "6px",
          display: "flex",
          flexDirection: "column",
          gap: "4px",
        }}
      >
        <Typography
          sx={{
            color: "secondary.main",
            fontSize: "14px",
          }}
        >
          {" "}
          محل بارگیری:
        </Typography>
        <Typography
          sx={{
            fontSize: "12px",
          }}
        >
          {senderAddress.address}
        </Typography>
      </Box>
      <Box
        sx={{
          mt: 1,
          boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.1) inset",
          borderRadius: "8px",
          backgroundColor: "bgColor.grey100",
          padding: "6px",
          display: "flex",
          flexDirection: "column",
          gap: "4px",
        }}
      >
        <Typography
          sx={{
            color: "secondary.main",
            fontSize: "14px",
          }}
        >
          {" "}
          توضیحات بار:{" "}
        </Typography>
        <Typography
          sx={{
            fontSize: "12px",
          }}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );
}
